import { render, staticRenderFns } from "./DefaultCollumn.vue?vue&type=template&id=4356b282"
import script from "./DefaultCollumn.vue?vue&type=script&lang=js"
export * from "./DefaultCollumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports